module.exports = __webpack_public_path__ + "img/fullsend_edible_1.927b9355.png";